import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { noAuthGuard } from './no-auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.LoginComponent),
    canActivate: [noAuthGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'trips',
    loadComponent: () => import('./pages/my-trips/my-trips').then(m => m.MyTripsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'frequent-places',
    loadComponent: () => import('./pages/frequent-places/frequent-places').then(m => m.FrequentPlacesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'approvals',
    loadComponent: () => import('./pages/approvals/approvals-dashboard/approvals-dashboard').then(m => m.ApprovalsDashboardComponent),
    canActivate: [authGuard],
    data: { roles: ['manager', 'admin', 'accounting'] }
  },
  {
    path: 'approvals/:userId/:monthKey',
    loadComponent: () => import('./pages/approvals/user-review/user-review').then(m => m.UserReviewComponent),
    canActivate: [authGuard],
    data: { roles: ['manager', 'admin', 'accounting'] }
  },
  {
    path: 'reports',
    loadComponent: () => import('./pages/reports/reports').then(m => m.ReportsComponent),
    canActivate: [authGuard],
    data: { roles: ['manager', 'admin', 'accounting'] }
  },
  {
    path: 'team',
    loadComponent: () => import('./pages/team-view/team-view').then(m => m.TeamViewComponent),
    canActivate: [authGuard],
    data: { roles: ['manager', 'admin', 'accounting'] }
  },
  {
    path: 'admin/settings',
    loadComponent: () => import('./pages/admin/system-settings/system-settings').then(m => m.SystemSettingsComponent),
    canActivate: [authGuard],
    data: { roles: ['admin'] }
  },
  {
    path: 'not-authorized',
    loadComponent: () => import('./pages/not-authorized/not-authorized').then(m => m.NotAuthorizedComponent),
    canActivate: [authGuard]
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
